import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function PageMeta({ title, description, noindex = false }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    const setMeta = (name, content, property = false) => {
      const attribute = property ? "property" : "name";
      let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.content = content;
    };
    setMeta("description", description);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:url", `https://www.ownersfirst.com.au${pathname}`, true);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://www.ownersfirst.com.au${pathname}`;
  }, [title, description, noindex, pathname]);
  return null;
}
